import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { usePopupModel, usePopupPopper } from './hooks';
import { Popper } from './Popper';
export const PopupPopper = createSubcomponent('div')({
    displayName: 'Popup.Popper',
    modelHook: usePopupModel,
    elemPropsHook: usePopupPopper,
})(({ children, ...elemProps }) => {
    return React.createElement(Popper, Object.assign({}, elemProps), children);
});
